import _ from 'lodash';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import AttachmentModal from 'components/attachments/attachment_modal';
import AttachmentPreviewOpener from 'components/lib/attachment/attachment_preview_opener';
import FbMessageIncomingAttachment from 'models/fb_message_incoming_attachment';
import FbMessageOutgoingAttachment from 'models/fb_message_outgoing_attachment';
import GenericAttachment from 'components/lib/attachment/generic_attachment';
import { getFbAttachmentUrl } from 'scripts/domain/services/attachments';
import { HandleHeightChange } from 'components/customer/conversation_history/virtualized/list_item';
import InlineImageAttachment from 'components/lib/attachment/inline_image_attachment';
import { useIsFeatureEnabled } from 'components/contexts/is_feature_enabled';

const FbMessageAttachmentsContainer = AttachmentPreviewOpener(FbMessageAttachments);

function FbMessageAttachments({ attachments, onOpenAttachmentPreview, orgId }) {
  const [previewAttachment, setPreviewAttachment] = useState(null);
  const isFeatureEnabled = useIsFeatureEnabled();
  const isRedactAttachmentsEnabled = isFeatureEnabled('redactAttachments');

  if (_.isEmpty(attachments)) {
    return null;
  }

  let [inlineImageAttachments, genericAttachments] = _.partition(
    attachments,
    a => !a.isRedacted && a.isImage() && a.isAvailable()
  );
  let availableAttachments = _.filter(inlineImageAttachments.concat(genericAttachments), a => a.isAvailable());

  return (
    <React.Fragment>
      <div className="fbMessageAttachments">
        <ul className="fbMessageAttachments-inlineImageAttachments">
          {_.map(inlineImageAttachments, renderInlineImageAttachment)}
        </ul>
        <ul className="genericAttachments">{_.map(genericAttachments, renderGenericAttachment)}</ul>
      </div>
      {previewAttachment && (
        <AttachmentModal
          attachment={previewAttachment}
          attachments={availableAttachments}
          setAttachment={setPreviewAttachment}
          url={getDownloadUrl(previewAttachment)}
        />
      )}
    </React.Fragment>
  );

  function renderGenericAttachment(attachment) {
    return (
      <GenericAttachment
        attachment={attachment}
        key={attachment.id}
        onClick={(attachment.isAvailable() && openAttachmentPreview) || undefined}
      />
    );

    function openAttachmentPreview() {
      if (isRedactAttachmentsEnabled) {
        setPreviewAttachment(attachment);
      } else {
        onOpenAttachmentPreview(availableAttachments, getDownloadUrl, getAttachmentIndex(attachment));
      }
    }
  }

  function renderInlineImageAttachment(attachment) {
    return (
      <HandleHeightChange key={attachment.id}>
        {({ onHeightChange }) => (
          <InlineImageAttachment
            attachmentId={attachment.id}
            inlinePreviewImageUrl={getPreviewUrl()}
            onClick={openAttachmentPreview}
            onLoad={onHeightChange}
          />
        )}
      </HandleHeightChange>
    );

    function getPreviewUrl() {
      return `${getDownloadUrl(attachment)}?size=preview`;
    }

    function openAttachmentPreview() {
      if (isRedactAttachmentsEnabled) {
        setPreviewAttachment(attachment);
      } else {
        onOpenAttachmentPreview(availableAttachments, getDownloadUrl, getAttachmentIndex(attachment));
      }
    }
  }

  function getAttachmentIndex(attachment) {
    return _.findIndex(availableAttachments, attachment);
  }

  function getDownloadUrl(a) {
    return getFbAttachmentUrl(orgId, a);
  }
}

FbMessageAttachmentsContainer.propTypes = {
  attachments: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.instanceOf(FbMessageIncomingAttachment),
      PropTypes.instanceOf(FbMessageOutgoingAttachment),
    ])
  ).isRequired,
};

FbMessageAttachments.propTypes = {
  ...FbMessageAttachmentsContainer.propTypes,
  ...AttachmentPreviewOpener.childPropTypes,
};

export { FbMessageAttachments };
export default FbMessageAttachmentsContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/facebook/attachments/fb_message_attachments.jsx